// 応答本文の Markdown リンク `[名称](wbs:コード)` から、チップ表示に使うコードを取り出す。
//
// WBS アイテムの code はプロジェクトコード・ユーザーコードと同じ 8 桁のランダム英数字で
// prefix を持たない（src/utils/code.ts の generateCode 参照）。本文スキャンでは他のコードと
// 見分けられないため、エージェント側のシステムプロンプトで `wbs:` スキームの明示マークアップを
// 強制している。ここではその契約に従っているリンクだけを認識する。
//
// 本文はモデル生成物であり、コードの値自体は信頼できない。/wbsItem/${code} という内部パスに
// そのまま埋め込むため、パス区切り・クエリ文字等が混ざった値を拾わないよう、
// generateCode が生成しうる文字種・桁数に厳密に一致する場合だけ有効なコードとして扱う。
// 一致しない場合は null を返し、呼び出し側は通常のリンク（またはプレーンテキスト）として
// 描画する（優雅な劣化）。
const WBS_LINK_SCHEME = 'wbs:'
const WBS_ITEM_CODE_PATTERN = /^[A-Z0-9]{8}$/

export const parseWbsItemLinkHref = (href: string): string | null => {
  if (!href.startsWith(WBS_LINK_SCHEME)) {
    return null
  }
  const code = href.slice(WBS_LINK_SCHEME.length)
  return WBS_ITEM_CODE_PATTERN.test(code) ? code : null
}
